export const getQueryParams = (search) => {
    return new URLSearchParams(search);
  };
  